var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 232,
    viewBox: "0 0 284 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.205 231.636C199.17 231.636 251.023 179.782 251.023 115.818C251.023 51.8534 199.17 -0.00012207 135.205 -0.00012207C71.2407 -0.00012207 19.3872 51.8534 19.3872 115.818C19.3872 179.782 71.2407 231.636 135.205 231.636Z",
    fill: "#DBF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9663 156.289C88.583 156.289 99.6216 145.25 99.6216 131.634C99.6216 118.017 88.583 106.979 74.9663 106.979C61.3496 106.979 50.3111 118.017 50.3111 131.634C50.3111 145.25 61.3496 156.289 74.9663 156.289Z",
    fill: "#8FD6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.021 94.4419C188.252 94.4419 195.736 86.9582 195.736 77.7265C195.736 68.4948 188.252 61.0111 179.021 61.0111C169.789 61.0111 162.305 68.4948 162.305 77.7265C162.305 86.9582 169.789 94.4419 179.021 94.4419Z",
    fill: "#8FD6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.304 188.884C198.381 188.884 204.93 182.336 204.93 174.258C204.93 166.18 198.381 159.632 190.304 159.632C182.226 159.632 175.678 166.18 175.678 174.258C175.678 182.336 182.226 188.884 190.304 188.884Z",
    fill: "#8FD6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2196 96.05H194.064V170.433C194.064 174.587 190.696 177.955 186.541 177.955H83.7416C79.5873 177.955 76.2196 174.587 76.2196 170.433V96.05Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.064 96.0498L137.527 56.7544C136.092 55.7578 134.191 55.7578 132.756 56.7544L76.2196 96.0498H194.064Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2197 96.05L134.187 136.34C134.761 136.738 135.522 136.738 136.096 136.34L194.064 96.05H76.2197Z",
    fill: "#006AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4768 55.1606C94.4768 51.4679 97.4705 48.4744 101.163 48.4744H168.597C172.29 48.4744 175.283 51.4679 175.283 55.1606V109.104L134.546 137.434L94.4768 108.745V55.1606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.736 167.09L136.284 131.536C135.37 130.821 134.085 130.826 133.177 131.549L88.5475 167.09",
    stroke: "#006AA3",
    strokeWidth: 3.34308,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.211 137.505L134.755 132.338L128.605 137.348L141.211 137.505Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.23 98.6205H104.219C103.065 98.6205 102.129 99.556 102.129 100.71C102.129 101.864 103.065 102.799 104.219 102.799H165.23C166.384 102.799 167.319 101.864 167.319 100.71C167.319 99.556 166.384 98.6205 165.23 98.6205Z",
    fill: "#B1BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.173 59.3394H105.472C103.626 59.3394 102.129 60.8362 102.129 62.6825V74.3833C102.129 76.2296 103.626 77.7264 105.472 77.7264H117.173C119.019 77.7264 120.516 76.2296 120.516 74.3833V62.6825C120.516 60.8362 119.019 59.3394 117.173 59.3394Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.201 81.9053H104.219C103.065 81.9053 102.129 82.8408 102.129 83.9948C102.129 85.1487 103.065 86.0842 104.219 86.0842H155.201C156.355 86.0842 157.29 85.1487 157.29 83.9948C157.29 82.8408 156.355 81.9053 155.201 81.9053Z",
    fill: "#B1BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.485 90.2633H104.219C103.065 90.2633 102.129 91.1988 102.129 92.3527C102.129 93.5067 103.065 94.4422 104.219 94.4422H138.485C139.639 94.4422 140.575 93.5067 140.575 92.3527C140.575 91.1988 139.639 90.2633 138.485 90.2633Z",
    fill: "#B1BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.098 106.979H104.219C103.065 106.979 102.129 107.914 102.129 109.068C102.129 110.222 103.065 111.158 104.219 111.158H120.098C121.252 111.158 122.188 110.222 122.188 109.068C122.188 107.914 121.252 106.979 120.098 106.979Z",
    fill: "#B1BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6944 62.7166L55.2697 75.5674L6.85211 18.8047L50.6944 62.7166Z",
    fill: "#006AA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0499 77.5052C24.7715 79.6699 27.4018 80.4916 29.2273 79.1225L71.8926 47.1234C73.8807 45.6323 73.6046 42.5702 71.3818 41.4588L5.57904 8.55741C3.5811 7.55842 1.37271 9.47371 2.0791 11.5928L24.0499 77.5052Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6938 62.7167L55.2691 75.5675L60.3039 55.8143L6.50336 12.1907L50.6938 62.7167Z",
    fill: "#008CD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.693 132.613C258.495 152.396 222.643 142.774 222.643 142.774L230.604 133.615C216.697 121.526 214.328 101.472 225.322 88.8257C236.315 76.1787 256.503 75.7331 270.411 87.8227C284.319 99.9123 286.687 119.966 275.693 132.613Z",
    fill: "#00A3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.483 97.2635C263.344 96.2731 261.617 96.394 260.628 97.5329L259.796 98.4888C255.442 96.3159 250.013 97.2458 246.669 101.092L239.498 109.343L236.004 109.097L235.999 109.093C235.387 109.005 234.768 109.23 234.356 109.702C233.698 110.459 233.779 111.614 234.536 112.273L253.788 129.008C254.545 129.666 255.7 129.585 256.358 128.828C256.769 128.356 256.906 127.71 256.728 127.112L255.998 123.687L263.171 115.436C266.514 111.59 266.679 106.085 263.922 102.075L264.753 101.119C265.743 99.9802 265.622 98.253 264.483 97.2635ZM240.216 119.625C238.899 121.14 239.061 123.448 240.576 124.765C242.091 126.082 244.4 125.921 245.717 124.406L240.216 119.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283.67,
    height: 231.636,
    fill: "white",
    transform: "translate(0.164856)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpConfirm);
export default __webpack_public_path__ + "static/media/signUpConfirm.28693eb5dd956a177555b551b65905b2.svg";
export { ForwardRef as ReactComponent };